import React from "react";
import AuthContext from "./AuthContext";

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    return (
      <AuthContext.Consumer>
        {(auth) => <Component {...props} auth={auth} />}
      </AuthContext.Consumer>
    );
  };
}
